module.exports = __webpack_public_path__ + "static/img/minip4.8196b3f6.png";